import React from "react";

const TestPage = () => {

    const instagramLinks = [
        "https://www.instagram.com/reel/DTwpPWbCIjH/",
        "https://www.instagram.com/reel/DRmjoOkDHXU/",
    ];

    return (
        <>
            <style>
                {`

          .Header {
             align-items: center;
             box-sizing: border-box;
             display: none;
             flex-direction: row;
             height: 84px;
             padding: 10px;
            }

          .insta-container {
            padding: 40px 20px;
            background: #f5f5f5;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            margin-top: 50px;
          }

          .insta-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 20px;
            max-width: 900px;
            width: 100%;
          }

          .insta-item iframe {
            width: 100%;
            height: 500px;
            border-radius: 12px;
            border: none;
            box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          }

          @media (max-width: 768px) {
            .insta-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
            </style>

            <div className="insta-container">
                <div className="insta-grid">

                    {instagramLinks.map((link, index) => (
                        <div key={index} className="insta-item">
                            <iframe
                                src={`${link}embed`}
                                scrolling="no"
                                allowTransparency="true"
                                loading="lazy"
                                title={`instagram-${index}`}
                            ></iframe>
                        </div>
                    ))}

                </div>
            </div>
        </>
    );
};

export default TestPage;
